const STORAGE_KEY = 'committee_context';

export const setCommitteeContext = (committee) => {
  if (!committee?.id || !committee?.slug) return;
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      id: committee.id,
      slug: committee.slug,
      name: committee.name || ''
    })
  );
};

export const getCommitteeContext = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
};

export const clearCommitteeContext = () => {
  localStorage.removeItem(STORAGE_KEY);
};

